module.exports = __webpack_public_path__ + "static/media/green_tick_wrapped.8fdbb12a.svg";